import css from './verify.module.scss';
import {Button} from '../../components/button/button';
import {Rewards} from '../../components/rewards/rewards';
import {REWARDS} from './verify.mock';
import {useNavigate} from '@tanstack/react-location';

export const Verify = (): JSX.Element => {
	const navigate = useNavigate();

	const onViewWallet = () => {
		navigate({to: '/wallet'});
	};

	return (
		<>
			<div className={css.header}>
				<img height={95} src="/img/getReward.svg" />
				<h3>2,000 SET Tokens</h3>
				<p>have been added to your account</p>
				<div className={css.viewWalletBtn}>
					<Button onClick={onViewWallet} color="lightBlue" name="View Wallet" />
				</div>
			</div>
			<div className={css.title}>Redeem Rewards with SET</div>

			<div className={css.body}>
				<Rewards list={REWARDS} />
				<div className={css.exploreBtn}>
					<Button color="blue" name="Explore Rewards" />
				</div>
			</div>
		</>
	);
};
